import { Card } from '../styles';
import { Dispatch, SetStateAction } from 'react';

interface EmailCardInterface {
  email: string;
  setEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveEmailModalShow: Dispatch<SetStateAction<boolean>>;
  deleteImage: string;
  emailOwnerName: string;
}

export default function EmailCard({
  email,
  emailOwnerName,
  setEmailToRemove,
  setRemoveEmailModalShow,
  deleteImage,
}: EmailCardInterface) {
  return (
    <Card>
      <div className="info">
        <div className="card-title">
          <strong>{email}</strong>
        </div>

        <span>
          Nome: {emailOwnerName}
        </span>
      </div>
      <div className="actions">
        <button
          type="button"
          onClick={() => {
            setEmailToRemove(email);
            setRemoveEmailModalShow(true);
          }}
        >
          <img
            src={deleteImage}
            alt="delete"
            title="Remover e-mail"
          />
        </button>
      </div>
    </Card>
  );
}
